<template lang="html">

  <div class="degustacionQuesos">

    <section class="banner-intro animation full-view-intro -middle column-center" data="degustacionQuesos">

      <h1 class="title -intro">{{$t('vistas.degustacionQuesos')}}</h1>

      <h2 class="subtitle-intro"><router-link :to="$t('enlaces.vive_aldonza')">{{$t('vistas.vive_aldonza')}}</router-link></h2>

    </section>

    <section class="intro-experiencias animation">

      <router-link :to="$t('enlaces.vive_aldonza')+'#'+$t('banners_experiencia.degustacionQuesos.id')" class="back">{{$t('volver')}}</router-link>

      <h2 class="title -xs -xxs container">{{$t('banners_experiencia.degustacionQuesos.titulo_intro_experiencia')}}</h2>

     <div class="container">
      <div class="contenedor-stats-quesos row-start column-start">
        <article v-for="el in $t('banners_experiencia.degustacionQuesos.productos')" @click="selected = el.id">
          <img :src="'/static/img/experiencia-queseria/'+el.id+'.png'" alt="" class="img-quesos">
          <p class="id">{{el.nombre}}</p> 
        </article>
      </div>
      
      </div>

      <div class="container-textos-stats-quesos">
        <img src="/static/img/experiencia-queseria/caballero.png" class="caballero">
        <article v-if="selected == el.id" v-for="el in $t('banners_experiencia.degustacionQuesos.productos')">
          <p><strong>{{el.nombre}}: </strong>{{el.descripcion}}</p>
          <hr>
        </article>
      </div>

    </section>

    <section class="new-texto-imagen row-center ais animation">

      <div class="textos -small column-center">
        <h3 class="title -xs">{{$t('banners_experiencia.degustacionQuesos.maridaje.titulo_catas')}}</h3>
        <div v-html="$t('banners_experiencia.degustacionQuesos.maridaje.cuerpo_catas')"></div>
      </div>
      <div class="contenedor-imagen">
        <img src="/static/img/queseria/imagen-maridaje.png" alt="Imagen de maridaje">
      </div>

    </section>


    



    <div class="contenedor-banner-localizaciones animation">

      <banner-localizaciones></banner-localizaciones>

    </div>
    <!-- <div class="banner-experiencia animation">

      <experiencia-queseria></experiencia-queseria>

    </div> -->
    
    <div class="contenedor-otras-experiencias animation">
      <otras-experiencias></otras-experiencias>
    </div>

  </div>

</template>

<script lang="js">

  import otrasExperiencias from '@/components/parts/otras-experiencias';
  import lasCatas from '@/components/views/experiencias/las-catas';
    import experienciaQueseria from '@/components/views/experiencias/experiencia-queseria';


  import formularioExperiencias from '@/components/views/experiencias/formulario-experiencias';

  import bannerLocalizaciones from '@/components/views/experiencias/banner-localizaciones'


  export default  {
    name: 'degustacionQuesos',
    components : {
      'otras-experiencias' : otrasExperiencias,
      'formulario-experiencias' : formularioExperiencias,
      'banner-localizaciones' : bannerLocalizaciones,
            'experiencia-queseria' : experienciaQueseria,
    },
    data : () => ({
      selected : 'vista'
    })
  }
</script>

<style scoped lang="scss">

  @import "@/assets/css/colors.scss";

  .degustacionQuesos{
    background: $mud-brown;
  }

  .full-view-intro[data=degustacionQuesos]{
    background: url("/static/img/queseria/background-intro-degustacionQuesos.png") center/cover no-repeat;
  }

  .title.-intro{
    overflow: visible;
    height: auto;
  }

  .intro-experiencias{
    background: $mud-brown;
    position: relative;
  }

  .intro-experiencias .title{
    text-align: center;
  }
.slider-product-list{
    display: none;
  }


.new-texto-imagen{
  padding-bottom: 0;
}

.contenedor-stats-quesos{
  
  will-change: transform;
  -webkit-transition: 1s;
  transition: 1s;
  z-index: 2;
  margin-top: 40px;
  margin-bottom: 40px;
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  align-items: stretch;

  article{
    width: 20%;
    padding:10px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction:column;
    cursor: pointer;
  }

}
.caballero{
  width: 10%;
  height: 35%;
  object-fit: contain;
  opacity: 05;
  position: absolute;
  right: 0px;
  top: 62%

}
.container-textos-stats-quesos{
  background-color: white;
  color:black;
  text-align: justify;
  padding: 80px;
  margin-bottom: 10px;
  padding-right: 120px;
  
}
@media screen and (max-width: 700px) {
  .container-textos-stats-quesos{
    padding: 34px 34px;
  }
}
.img-quesos{

  max-width: 100px;
  max-height: 100px;
  margin-bottom: 50px;

}
.img-quesos:hover{
  transform: scale(1.2) translateY(20px);
  transition: 1s;

}

hr{
  margin-top: 25px;
}

.id{
  text-align: center;
}

@media screen and (max-width: 700px){

    .caballero{
      width: 20%;
      height: 35%;
      object-fit: contain;
      opacity: 05;
      position: absolute;
      right: 0px;
      top: 62%

    }


}

@media screen and (max-width: 650px){
    .caballero{
        width: 30%;
      }


    .contenedor-stats-quesos{
    
      display:flex;
      flex-direction:row;
      flex-wrap:wrap;
      justify-content:center;

      

    article{
      width: 10%;
      padding:20px 46px;
      margin: 10px 1px;
      flex-direction:column;
    }
  }
    .id{
      padding-right: 45px;
      padding-top: 24px
      
    }
  .img-quesos{

    max-width: 45px;
    max-height: 50px;
    margin-bottom: 10px;

  }
  .img-quesos:hover{
    transform: scale(1.2) translateY(10px);
  }

}





  .contenedor-formulario{
    background: url("/static/img/queseria/background-formulario.png") center/cover no-repeat;
    height: 695px;
    display: inline-block;
    width: 100%;
    margin-top: 100px;
  }

  .intro-experiencias{
    padding-bottom: 0;
  }

  .launched{
    .contenedor-imagen{
      opacity: 1;
      transform: translateY(0px);
    }
  }

  @media screen and (max-width: 1100px){

    .new-texto-imagen{
      padding-top: 50px;
      padding-bottom: 100px;
    }
    .new-texto-imagen .textos{
      transform: translateY(0);
      margin-top: 50px;
    }
  }

 @media screen and (max-width: 1050px){
   .contenedor-formulario{
    height: 725px;

  }
 }

  @media screen and (max-width: 960px){
   .contenedor-formulario{
    height: 740px;

  }
 }

   @media screen and (max-width: 840px){
   .contenedor-formulario{
    height: 775px;

  }
 }

   @media screen and (max-width: 825px){
   .contenedor-formulario{
    height: 800px;
    margin-bottom: 395px

  }
 }

 @media screen and (max-width: 760px){
   .contenedor-formulario{
    height: 855px;

  }
 }


  @media screen and (max-width: 700px){
   .contenedor-formulario{
    height: 975px;

  }
 }

  @media screen and (max-width: 580px){
   .contenedor-formulario{
    margin-bottom: 470px

  }
 }
   @media screen and (max-width: 530px){
   .contenedor-formulario{
    margin-bottom: 650px

  }
 }
    @media screen and (max-width: 370px){
   .contenedor-formulario{
    margin-bottom: 720px

  }
 }

 
@media screen and (max-width: 546px){
  .contenedor-stats-quesos{

    article{
      padding:20px 40px;
    }
  }
}
@media screen and (max-width: 490px){
  .contenedor-stats-quesos{

    article{
      padding:20px 37px;
    }
  }
}
@media screen and (max-width: 450px){
  .contenedor-stats-quesos{

    article{
      padding:20px 33px;
    }
  }
}
@media screen and (max-width: 400px){
  .contenedor-stats-quesos{

    article{
      padding:20px 30px;
    }
  }
}
@media screen and (max-width: 380px){
  .contenedor-stats-quesos{

    article{
      padding:20px 28px;
    }
  }
}
@media screen and (max-width: 360px){
  .contenedor-stats-quesos{

    article{
      padding:20px 25px;
    }
  }
}
@media screen and (max-width: 330px){
  .contenedor-stats-quesos{

    article{
      padding:20px 31px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/experiencias/degustacionQuesos.vue